module.exports = "query GetSponsor($id: ID!) {\n  sponsor(id: $id) {\n    ...MinimalSponsorFragment\n  }\n}\n"